import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
/**
 * Error component.
 * @param error: string
 * @returns
 */
export const ErrorComponent = ({ error }) => (_jsx(Box, { children: _jsx(Typography, { children: error }) }));
